<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.provinceId"
              filterable
              clearable
              placeholder="请选择省区"
              style="width:100%"
              @change="changeProvinceFun"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.settingId"
              filterable
              clearable
              placeholder="请选择周期"
              style="width:100%"
              @change="changeSettingIdFun"
            >
              <el-option
                v-for="item in settingIdOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.cityName"
              placeholder="请输入城市名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @edit="editFun(arguments)"
        @efficient="efficientFun(arguments)"
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 有效性设置-->
    <efficient-dialog
      :data-id="id"
      :dialog-title="dialogEfficientTitle"
      :dialog-visible.sync="dialogEfficientVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 有效性设置
import EfficientDialog from './components/efficientDialog'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadRetailSurveyItemListDataApi, loadRetailSurveyItemExportDataApi, loadRetailSurveyExportCycleSettingSelectDataApi } from '@/api/retailSurveyInfo'
export default {
  name: 'RetailSurveyItem',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog,
    EfficientDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'retail_survey_item_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['retail_survey_item_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['retail_survey_item_efficient_setting'],
            prop: 'efficient',
            label: '有效性设置',
            method: 'efficient'
          },
          {
            permissionSigns: ['retail_survey_item_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            certificateNo: '',
            provinceId: '',
            cityName: '',
            settingId: '',
            searchStartDate: '',
            searchEndDate: ''
          }
        }
      },
      id: null, // 选中的单据ID
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      eventType: 'edit',
      dialogEfficientTitle: '',
      dialogEfficientVisible: false,
      provinceOptions: [],
      settingIdOptions: []
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 's.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 's.city_name', width: 80 },
      { prop: 'countyName', label: '区县', filterColumn: 's.county_name', width: 100 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 's.certificate_no', width: 160 },
      { prop: 'storeName', label: '零售户名称', filterColumn: 's.store_name', width: 160 },
      { prop: 'levelStr', label: '当前档位', filterColumn: 's.level_str', width: 80 },
      { prop: 'levelName', label: '采集档位', filterColumn: 'i.level_name', width: 80 },
      { prop: 'productName', label: '采集品规', filterColumn: 't.name', width: 160 },
      { prop: 'rangeName', label: '价格区间', filterColumn: 'prs.name', width: 160 },
      { prop: 'collectionDateStr', label: '采集时间', filterColumn: 'i.collection_date', width: 110, isBetween: true },
      { prop: 'collectionUserName', label: '采集人', filterColumn: 'i.collection_user_name', width: 100 },
      { prop: 'collectStatusStr', label: '采集状态', filterColumn: '(case i.collect_status when 1 then \'采集完成\' else \'采集中\' end)', width: 120 },
      { prop: 'periodReceiptDateStr', label: '本周期到货日期', filterColumn: 'if(i.period_receipt_date is null, \'\', date_format(i.period_receipt_date,\'%Y-%m-%d\'))', width: 150 },
      // { prop: 'weekSalesAmount', label: '本周总销售(条)', filterColumn: 'i.week_sales_amount', width: 140, isBetween: true },
      // { prop: 'totalInventoryAmount', label: '当前总库存(条)', filterColumn: 'i.inventory_amount', width: 140, isBetween: true },
      // { prop: 'yunWeekSalesAmount', label: '云产烟总销售(条)', filterColumn: 'i.yun_week_sales_amount', width: 160, isBetween: true },
      // { prop: 'yunInventoryAmount', label: '云产烟总库存(条)', filterColumn: 'i.yun_inventory_amount', width: 160, isBetween: true },
      { prop: 'lastInventoryAmount', label: '上周期库存(条)', filterColumn: 'item.last_inventory_amount', width: 150, isBetween: true },
      { prop: 'orderAmount', label: '本周期到货(条)', filterColumn: 'item.order_amount', width: 130, isBetween: true },
      { prop: 'inventoryAmount', label: '当前库存(条)', filterColumn: 'item.inventory_amount', width: 130, isBetween: true },
      { prop: 'salesAmount', label: '本周期销售(条)', filterColumn: 'item.sales_amount', width: 130, isBetween: true, isNegativeRed: true },
      // { prop: 'packagePrice', label: '包零售价', filterColumn: 'item.package_price', width: 120, isBetween: true },
      // { prop: 'orderPrice', label: '条零售价', filterColumn: 'item.order_price', width: 120, isBetween: true },
      { prop: 'codeSalesPrice', label: '本码出货价', filterColumn: 'item.code_sales_price', width: 130, isBetween: true },
      { prop: 'isCompleteStr', label: '是否完成', filterColumn: '(case item.is_complete when 1 then \'是\' else \'否\' end)', width: 120 },
      { prop: 'noCollectReasonStr', label: '未完成原因', filterColumn: '(case item.no_collect_reason when 1 then \'未售\' when 2 then \'不配合\' when 3 then \'关门\' when 4 then \'其他\' when 5 then \'未售(不愿意订)\' when 6 then \'未售(订不到)\' else \'\' end)', width: 140 },
      { prop: 'isEfficientStr', label: '是否有效样本', filterColumn: '(case item.is_efficient when 1 then \'有效\' else \'无效\' end)', width: 130 },
      { prop: 'noEfficientReason', label: '无效原因', filterColumn: 'item.no_efficient_reason', width: 160 },
      { prop: 'efficientOperatorName', label: '设置人', filterColumn: 'item.efficient_operator_name', width: 120 },
      { prop: 'efficientOperationTimeStr', label: '设置时间', filterColumn: 'item.efficient_operation_time', width: 160, isBetween: true },
      { prop: 'operationTimeStr', label: '操作时间', filterColumn: 'item.operation_time', width: 160 }
    ]
    this.initProvinceSelectData()
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadRetailSurveyItemListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 省区选择回调
    changeProvinceFun (val) {
      this.settingIdOptions = []
      this.masterList.tableQuery.search.settingId = ''
      this.masterList.tableQuery.search.searchStartDate = ''
      this.masterList.tableQuery.search.searchEndDate = ''
      if (val === null || val === '') {
        return false
      }
      this.initSettingSelectData(val)
    },
    // 初始期数下拉数据
    initSettingSelectData (val) {
      loadRetailSurveyExportCycleSettingSelectDataApi({ provinceId: val, orderCondition: 'order by id desc limit 20' }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.settingIdOptions.push({ label: item.name, data: item.id, startDate: item.startDateStr, endDate: item.endDateStr })
        })
      })
    },
    // 周期选择
    changeSettingIdFun (val) {
      this.masterList.tableQuery.search.searchStartDate = ''
      this.masterList.tableQuery.search.searchEndDate = ''
      let selectItem = this.settingIdOptions.find(item => {
        return item.data === val
      })
      if (selectItem) {
        this.masterList.tableQuery.search.searchStartDate = selectItem.startDate
        this.masterList.tableQuery.search.searchEndDate = selectItem.endDate
      }
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改零售监测明细'
    },
    // 有效性设置
    efficientFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogEfficientVisible = !this.dialogEfficientVisible
      this.dialogEfficientTitle = '有效性设置'
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadRetailSurveyItemExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.warning-row {
  background: rgb(255, 158, 158);
}
</style>